import { Button } from '@/atoms/Button'
import { FlexColumn } from '@/atoms/FlexContainers'
import { Image } from '@/atoms/Image'
import { Text } from '@/atoms/Text'
import { useTranslate } from '@/utils/translate/translate-client'

export const PresaleUpdatesTab = ({ scroll }: { scroll: () => void }) => {
  const { t } = useTranslate('tickets')

  return (
    <FlexColumn className="mx-auto mb-16 gap-16 px-4 pt-16 md:gap-[72px] md:px-16 md:pb-32 lg:px-24">
      <Text color="homestead-primary-blue" className="homestead-title-lg md:homestead-title-xl uppercase">
        {t('preOrderUpdates', 'Pre-order Updates')}
      </Text>
      <FlexColumn className="items-center gap-6">
        <Image
          src="https://images.angelstudios.com/image/upload/v1725487463/homestead-container-illustration-01_1.webp"
          alt=""
          width={190}
          height={130}
          className="md:hidden"
        />
        <Image
          src="https://images.angelstudios.com/image/upload/v1725487463/homestead-container-illustration-01_1.webp"
          alt=""
          width={240}
          height={164}
          className="hidden md:block"
        />
        <Text color="homestead-blue" className="homestead-paragraph-sm md:homestead-paragraph-md">
          {t('noUpdates', 'There are no updates at this time.')}
        </Text>
        <Button
          className="w-full border-none !bg-homestead-red !py-[17px] md:hidden"
          onClick={scroll}
          variant="core-gray-900"
        >
          <Text color="white" className="homestead-btn-md uppercase">
            {t('preOrderTickets', 'Pre-Order Tickets')}
          </Text>
        </Button>
      </FlexColumn>
    </FlexColumn>
  )
}
